import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Container,
    FormControlLabel,
    useMediaQuery,
    useTheme
} from "@mui/material";
import {useState} from "react";


function Video() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent:'center',
                alignItems:'center',
                width: '100vw',
            }}
        >
            <header style={{flex: '0 0 auto'}}>
                <img
                    src={"/assets/header-desktop.jpg"}
                    alt="Header"
                    style={{width: '100%', display: 'block', height:'100%'}}
                />
            </header>

            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '60vw',
                aspectRatio: '16 / 9',
                flexDirection: 'column',
                padding: '16px'
            }}>
                {/*<Typography variant={"h3"}>
                  The event will start soon
              </Typography>*/}

                    <iframe
                        src="https://player.vimeo.com/video/1051534230?h=9044a6e81f&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                        style={{width: "100%", height: "100%"}} title="Alleanza Teaser"></iframe>

                <script src="https://player.vimeo.com/api/player.js"></script>
            </div>


            {loading &&
                <main style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: '1 0 auto',
                    overflowY: 'auto',
                    textAlign: 'center',
                    margin: 'auto',
                    height: !isMobile ? '360px' : 'auto'
                }}>
                    <CircularProgress/>
                </main>
            }


            <footer style={{flex: '0 0 auto'}}>
                <img
                    src="/assets/footer.jpg"
                    alt="Footer"
                    style={{width: '100%', display: 'block'}}
                />
            </footer>

        </div>
    );
}

export default Video;